import { bpHistory } from 'global/bpHistory';
import { generatePath } from 'react-router-dom';
import { RouteV2Id, ROUTES_CONFIG_V2 } from './routesConfigV2';

/**
 * TEMPORARY: `/browsing` still reads group / period / cart from the query string (legacy).
 * Remove when the browsing page is reworked and uses the same param style as other quote routes.
 */
function browsingShelfQuoteSearchParams(params: Record<string, string>): string {
  const search = new URLSearchParams();
  if (params.groupId !== undefined) search.set('groupId', params.groupId);
  if (params.periodId !== undefined) search.set('periodId', params.periodId);
  if (params.cartId !== undefined) search.set('cartId', params.cartId);
  if (params.productLineId !== undefined) search.set('productLineId', params.productLineId);
  search.set('type', 'initiate');
  return search.toString();
}

/**
 * Redirects to a route with the provided params.
 *
 * @param routeId - Target route ID from RouteV2Id.
 * @param params - Route parameters.
 *
 * @example
 * redirectToRoute(RouteV2Id.INITIATE_PROPOSAL, { groupId: '123' });
 */
export const redirectToRoute = (routeId: RouteV2Id, params: Record<string, string>): void => {
  if (routeId === RouteV2Id.INITIATE_SHELF_BROWSING) {
    bpHistory.push(`${ROUTES_CONFIG_V2[routeId].path}?${browsingShelfQuoteSearchParams(params)}`);
    return;
  }

  bpHistory.push(generatePath(ROUTES_CONFIG_V2[routeId].path, params));
};
